/**
 * Scan POS -- the ONE place that decides whether this build may use the
 * Remote Scanner at all, and which WebSocket it may open.
 *
 * Each Backend has its OWN WebSocket and a page only ever gets the one
 * that belongs to the API it already talks to: the Staging API gets the
 * Staging socket, the Production API gets the Production socket. There is
 * deliberately no fallback and no cross-over -- a Production page can
 * never open the Staging socket, and no Production session ever reaches
 * Staging through it. Any other API (an unknown host, a typo, a trailing
 * slash) gets nothing, so the feature stays off rather than half-working.
 *
 * Production joined on 13-14.10.2026 (owner: "make Production scan, working
 * like the Pilot"), once its Backend carried the Scan POS routes and the
 * `jinda-pos-api-prod-realtime` WebSocket API `9x8rpi1dy0` existed.
 */
import { base_url, PRODUCTION_API, STAGING_API } from '../api/api-config';

/** The Staging WebSocket stage approved for P6 (P4 API `9o73o6ii4f`). */
export const STAGING_REALTIME_URL = 'wss://9o73o6ii4f.execute-api.ap-southeast-1.amazonaws.com/staging';

/** The Production WebSocket stage (API `9x8rpi1dy0`, stack jinda-pos-api-prod). */
export const PRODUCTION_REALTIME_URL = 'wss://9x8rpi1dy0.execute-api.ap-southeast-1.amazonaws.com/prod';

/** The realtime URL for [apiUrl], or null when this API has none. */
export const resolveRealtimeUrl = (apiUrl: string = base_url): string | null =>
    apiUrl === STAGING_API ? STAGING_REALTIME_URL
        : apiUrl === PRODUCTION_API ? PRODUCTION_REALTIME_URL
        : null;

/** True only when the Scan POS Backend exists behind [apiUrl]. */
export const isScanPosAvailable = (apiUrl: string = base_url): boolean => resolveRealtimeUrl(apiUrl) !== null;
